import type { ITripLeg } from '../../../../../../../../models/trip-leg.model';
import WheelchairIcon from '../../../../../../../Shared/WheelchairIcon';
import { TranslationService } from '../../../../../../../../services/translation.service';
import { TransportModeHelper } from '../../../../../../../../helpers/transport-mode.helper';
import type { ITripLegDetails } from '../../../../../../../../models/trip-leg-details.model';
import { LegHelper } from '../../../../../../../../helpers/leg.helper';
import Notes from './components/Notes';
import DataUrlHelper from '../../../../../../../../helpers/data-url.helper';
import greaterThanIcon from '../../../../../../../../../assets/icons/chevron-right-default-gray-900.svg';
import './style.scss';
import Occupancy from '../../../../../../../Shared/Occupancy';
import { DirectionHelper } from '../../../../../../../../helpers/direction.helper';
import { TransportMode } from '../../../../../../../../models/transport-mode.enum';
import { WheelchairIconType } from '../../../../../../../Shared/WheelchairIcon/wheelchair-icon-type.enum';
import LineBadge from '../../../../../../../Shared/LineBadge';

function TripLeg({ tripLeg, tripLegDetails, onTriplegSelected }: { tripLeg: ITripLeg; tripLegDetails: ITripLegDetails; onTriplegSelected: (tripLeg: ITripLeg) => void }) {
  const allNotes = LegHelper.getAllTripLegNotes(tripLeg);

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a
        href="#"
        className="trip-leg text-decoration-none d-block btn--outline-internal"
        onClick={(e) => {
          e.preventDefault();
          onTriplegSelected(tripLeg);
        }}
      >
        <span className="visually-hidden">{TranslationService.get('travelplanner.readmoreabouttripleg')}</span>
        <div className={`bg-gray p-3 rounded ${allNotes.length > 0 ? 'mb-2' : ''}`}>
          <div className="d-flex mb-2">
            <div className="flex-shrink-0">{tripLeg.serviceJourney.line && <LineBadge line={tripLeg.serviceJourney.line} className="me-1" />}</div>
            <span className="align-self-center flex-grow-1 text-color-gray-900">{DirectionHelper.getDirectionForDisplay(tripLeg.serviceJourney)}</span>
            <img src={DataUrlHelper.encode(greaterThanIcon)} alt="" className="flex-shrink-0 align-self-center trip-leg__button-icon d-print-none" />
          </div>
          <div className="d-flex align-items-center text-color-gray-800">
            <div>
              {tripLeg.serviceJourney.line?.transportMode && tripLeg.serviceJourney.line?.transportMode !== TransportMode.unknown && (
                <span>{TransportModeHelper.translate(tripLeg.serviceJourney.line?.transportMode)}</span>
              )}
              {tripLeg.serviceJourney.line?.transportMode && tripLeg.serviceJourney.line?.transportMode === TransportMode.unknown && (
                <span>{DirectionHelper.getDirectionForUnknownTransportMode(tripLeg.serviceJourney)}</span>
              )}
              {tripLeg.serviceJourney.directionDetails?.isFrontEntry && <span>, {TranslationService.get('travelplanner.boardingfront')}</span>}
            </div>
            {tripLeg.serviceJourney.line && tripLeg.serviceJourney.line.isWheelchairAccessible && <WheelchairIcon className="ms-1" iconType={WheelchairIconType.dark} sizeInRem={1.5} />}
            {tripLeg.occupancy && <Occupancy occupancy={tripLeg.occupancy} className="ms-1" showAltText={true} />}
          </div>
          <span className={'text-color-gray-800'}>
            {tripLeg.estimatedDurationInMinutes ?? tripLeg.plannedDurationInMinutes} min (
            {tripLegDetails.callsOnTripLeg
              ? `${tripLegDetails.callsOnTripLeg.length - 1} ${tripLegDetails.callsOnTripLeg.length === 2 ? TranslationService.get('common.stop') : TranslationService.get('common.stops')}`
              : ''}
            )
          </span>
        </div>
      </a>
      {allNotes.length > 0 && <Notes notes={allNotes} />}
    </>
  );
}

export default TripLeg;
